import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section className="border-y border-accent-200 bg-accent-50" aria-labelledby="subscribe-title">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.3em] text-accent-700 font-medium">订阅与投稿</p>
            <h2 id="subscribe-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              每周一封核实周报，外加一个纠错入口
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              周报会汇总本周热度最高的爆料、最新辟谣结果和仍在核实的悬案。你也可以用它投稿新线索，或者指出我们判定中的疏漏。
            </p>
            <ul className="mt-6 space-y-3 text-sm text-foreground-700">
              {[
                '每周一封，不打扰，随时可退订',
                '只推送已核实的结论与依据，不推情绪',
                '纠错反馈核实后会公开更正',
              ].map((t) => (
                <li key={t} className="flex items-start gap-2">
                  <span className="mt-1 w-4 h-4 flex items-center justify-center text-accent-700 shrink-0">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  {t}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-7">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}